import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { useSelector } from "react-redux";

const WaterfallChartComponent = () => {
  const pid = useSelector((state) => state.user.projectId);

  const [orgOptions, setOrgOptions] = useState([]);
  const [schemeOptions, setSchemeOptions] = useState([]);
  const [schemeTypeOptions, setSchemeTypeOptions] = useState([]);
  const [caseDistrictOptions,setCaseDistrictOptions]=useState([]);

  // NEW
  const [thematicAreaOptions, setThematicAreaOptions] = useState([]);

  const [selectedOrgs, setSelectedOrgs] = useState([]);
  const [selectedSchemes, setSelectedSchemes] = useState([]);
  const [selectedSchemeTypes, setSelectedSchemeTypes] = useState([]);
  const [selectedCaseDistrict,setSelectedCaseDistrict]=useState([]);

  // NEW
  const [selectedThematicAreas, setSelectedThematicAreas] = useState([]);

  const [waterfallData, setWaterfallData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [metricsData, setMetricsData] = useState([]);
  const [schemeBenefit, setSchemeBenefit] = useState(0);

  const getQueryParams = () => {
    const params = new URLSearchParams();
    selectedSchemeTypes.forEach(type => params.append("SchemeType", type));
    selectedOrgs.forEach(org => params.append("OrgName", org));
    selectedSchemes.forEach(scheme => params.append("SchemeName", scheme));
    selectedCaseDistrict.forEach(district => params.append("CaseDistrict", district));

    // NEW
    selectedThematicAreas.forEach(area => params.append("ThematicArea", area));

    if (pid) params.append("pid", pid);
    return params.toString();
  };

 const mergeOptions = (selected, fetched) => {
    const map = new Map();
    [...selected, ...fetched].forEach(opt => map.set(opt.value, opt));
    return Array.from(map.values());
  };

const schemeTypeLabelMap = {
  sch: "Schemes",
  doc: "Document",
  dfl: "DFL",
  yc: "Yojana Card"
};

const fetchFilterOptions = async () => {
  try {
    const params = getQueryParams();

    const [orgRes, schemeRes, schemeTypeRes,caseDistrictRes,thematicRes] = await Promise.all([
      fetch(`https://api-project360-insights.haqdarshak.com/kpi/waterfall/unique-org/?${params}`),
      fetch(`https://api-project360-insights.haqdarshak.com/kpi/waterfall/unique-scheme/?${params}`),
      fetch(`https://api-project360-insights.haqdarshak.com/kpi/waterfall/unique-scheme-type/?${params}`),
      fetch(`https://api-project360-insights.haqdarshak.com/kpi/waterfall/unique-case-districts/?${params}`),
      fetch(`https://api-project360-insights.haqdarshak.com/kpi/waterfall/unique-thematic-areas/?${params}`)
    ]);

    const orgData = await orgRes.json();
    const schemeData = await schemeRes.json();
    const schemeTypeData = await schemeTypeRes.json();
    const caseDistrictData=await caseDistrictRes.json();
    const thematicData = await thematicRes.json();

    const orgOpts = orgData.unique_Organizations.map(o => ({ value: o, label: o }));
    const schemeOpts = schemeData.unique_Schemes.map(s => ({ value: s, label: s }));
    const caseDistrictOpts = caseDistrictData.unique_case_districts.map(c => ({ value: c, label: c }));

    const thematicOpts = thematicData.unique_thematic_areas.map(t => ({
      value: t,
      label: t
    }));

    const schemeTypeOpts = schemeTypeData.unique_Scheme_Types.map(t => ({
      value: t,
      label: schemeTypeLabelMap[t] || t
    }));

    setOrgOptions(mergeOptions(orgOptions, orgOpts));
    setSchemeOptions(mergeOptions(schemeOptions, schemeOpts));
    setSchemeTypeOptions(mergeOptions(schemeTypeOptions, schemeTypeOpts));
    setCaseDistrictOptions(mergeOptions(caseDistrictOptions,caseDistrictOpts));

    // NEW
    setThematicAreaOptions(mergeOptions(thematicAreaOptions,thematicOpts));

  } catch (error) {
    console.error('Error fetching filter options:', error);
  }
};

  useEffect(() => {
    fetchFilterOptions();
  }, [selectedOrgs, selectedSchemes, selectedSchemeTypes,selectedCaseDistrict,selectedThematicAreas,pid]);

  useEffect(() => {
    const fetchChartData = async () => {
      setLoading(true);
      try {
        const params = getQueryParams();

        const chartRes = await fetch(`https://api-project360-insights.haqdarshak.com/kpi/waterfall/chart/?${params}`);
        const chartData = await chartRes.json();

        const transformedData = [
  { name: 'Total Cases Created', value: chartData.TotalCases, fill: '#CF87C4' },
  { prefix: 'Net', name: 'Application Open', value: chartData.application_open, fill: '#CF87C4' },
  { prefix: 'Net', name: 'Docket Submitted', value: chartData.docket_submitted, fill: '#CF87C4' },
  { prefix: 'Net', name: 'BR Count', value: chartData.br_count, fill: '#CF87C4' },
  
];

        const tableData = [
  ...transformedData,
  { name: 'Aborted Cases', value: chartData.aborted_count, fill: '#CF87C4' },
  { name: 'Application Rejected Count', value: chartData.rejected_count, fill: '#CF87C4' } 
];

        const metricData = [
          { name: 'Application Open', value: chartData.application_open, fill: '#CF87C4' },
          { name: 'Docket Submitted', value: chartData.docket_submitted, fill: '#CF87C4' },
          { name: 'BR Count', value: chartData.br_count, fill: '#CF87C4' }
        ];

        setWaterfallData(metricData);
        setMetricsData(tableData);

        const benefitRes = await fetch(`https://api-project360-insights.haqdarshak.com/kpi/scheme-benefits/?${params}`);
        const benefitData = await benefitRes.json();

        setSchemeBenefit(benefitData.br_value || 0);

      } catch (error) {
        console.error('Error fetching chart/benefit data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchChartData();
  }, [selectedOrgs, selectedSchemes, selectedSchemeTypes,selectedCaseDistrict,selectedThematicAreas,pid]);

  const MultiSelectDropdown = ({ options, selected, setSelected, placeholder }) => (
    <Select
      isMulti
      options={options}
      value={options.filter(opt => selected.includes(opt.value))}
      onChange={(selectedOptions) => setSelected(selectedOptions.map(o => o.value))}
      placeholder={placeholder}
      className="w-full"
      closeMenuOnSelect={false}
    />
  );

const currentOpen = Math.max(
  (metricsData.find(m => m.name === "Application Open")?.value || 0) -
  (metricsData.find(m => m.name === "Docket Submitted")?.value || 0), 
  0
);

const currentDS = Math.max(
  (metricsData.find(m => m.name === "Docket Submitted")?.value || 0) -
  (metricsData.find(m => m.name === "BR Count")?.value || 0), 
  0
);

const currentBR = metricsData.find(m => m.name === "BR Count")?.value || 0;

  const clearFilters = () => {
    setSelectedOrgs([]);
    setSelectedSchemes([]);
    setSelectedSchemeTypes([]);
    setSelectedCaseDistrict([]);

    // NEW
    setSelectedThematicAreas([]);
  };

  return (
  <div className="w-[90vw] ml-[3vw] border-2 border-gray-300 shadow-md rounded-md">

    {/* HEADER */}
    <div className="bg-gray-50 px-4 md:px-6 py-4 border rounded-lg mb-4">
      <h2 className="text-lg md:text-xl font-semibold text-pink-800">
        Summary View
      </h2>
      <p className="text-sm text-pink-800 mt-1">
        Filter and analyze your data
      </p>
    </div>

    {/* MAIN LAYOUT */}
    <div className="flex flex-col lg:flex-row gap-4">

      {/* LEFT METRIC CARDS */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-1 gap-3 w-full lg:w-64">
        {metricsData.map((item, index) => (
          <div
            key={index}
            className="bg-white p-4 rounded-lg shadow border"
          >
            <p className="text-sm text-gray-500">
              {item.prefix && (
                <sup className="text-[9px] mr-1">{item.prefix}</sup>
              )}
              {item.name}
            </p>

            <p className="text-xl md:text-2xl font-bold" style={{ color: item.fill }}>
              {item.value?.toLocaleString()}
            </p>
          </div>
        ))}
      </div>

      {/* RIGHT CONTENT */}
      <div className="flex-1">

        {/* FILTERS */}
        <div className="bg-white rounded-lg shadow p-4 md:p-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">

          <div>
            <label className="text-sm font-medium">Organization</label>
            <MultiSelectDropdown {...{
              options: orgOptions,
              selected: selectedOrgs,
              setSelected: setSelectedOrgs,
              placeholder: "Select organization..."
            }} />
          </div>

          <div>
            <label className="text-sm font-medium">Service Type</label>
            <MultiSelectDropdown {...{
              options: schemeTypeOptions,
              selected: selectedSchemeTypes,
              setSelected: setSelectedSchemeTypes,
              placeholder: "Select service type..."
            }} />
          </div>

          <div>
            <label className="text-sm font-medium">Scheme Name</label>
            <MultiSelectDropdown {...{
              options: schemeOptions,
              selected: selectedSchemes,
              setSelected: setSelectedSchemes,
              placeholder: "Select scheme..."
            }} />
          </div>

          <div>
            <label className="text-sm font-medium">Case District</label>
            <MultiSelectDropdown {...{
              options: caseDistrictOptions,
              selected: selectedCaseDistrict,
              setSelected: setSelectedCaseDistrict,
              placeholder: "Select district..."
            }} />
          </div>

          <div>
            <label className="text-sm font-medium">Thematic Area</label>
            <MultiSelectDropdown {...{
              options: thematicAreaOptions,
              selected: selectedThematicAreas,
              setSelected: setSelectedThematicAreas,
              placeholder: "Select thematic area..."
            }} />
          </div>

          <div className="flex items-end">
            <button
              onClick={clearFilters}
              className="bg-red-700 hover:bg-red-800 text-white px-4 py-2 rounded w-full"
            >
              Clear Filters
            </button>
          </div>
        </div>

        {/* CHART + BENEFIT */}
        <div className="flex flex-col lg:flex-row gap-4 mt-4">

          {/* CHART */}
<div className="flex-1 bg-white p-4 md:p-6 rounded-lg shadow border border-gray-200">

  {loading ? (
    <div className="flex justify-center h-40 items-center">
      <div className="animate-spin h-10 w-10 border-2 border-blue-500 rounded-full"></div>
    </div>
  ) : waterfallData.length > 0 ? (
    <div className="flex flex-col items-center">

      <div className="w-full h-44 flex flex-col justify-end space-y-1 relative">

        {/* Center Line */}
        <div className="absolute left-1/2 top-0 bottom-0 w-px bg-gray-300 transform -translate-x-1/2"></div>

        {(() => {
          const max = Math.max(...waterfallData.map((item) => item.value), 1);

          // ✅ Correct base values
          const total = metricsData.find(m => m.name === "Total Cases Created")?.value || 1;
          const appOpen = metricsData.find(m => m.name === "Application Open")?.value || 1;
          const docket = metricsData.find(m => m.name === "Docket Submitted")?.value || 1;

          return waterfallData.map((item) => {
            let pct = 0;

            if (item.name === "Application Open") {
              pct = Math.round((item.value /appOpen) * 100);
            } 
            else if (item.name === "Docket Submitted") {
              pct = Math.round((item.value / appOpen) * 100);
            } 
            else if (item.name === "BR Count") {
              pct = Math.round((item.value / appOpen) * 100);
            }

            if (!isFinite(pct)) pct = 0;

            // ✅ SAME WIDTH LOGIC (unchanged)
            const proportionalWidth = (item.value / max) * 25;
            const halfWidth = Math.max(proportionalWidth, 7.5);

            return (
              <div key={item.name} className="flex justify-center relative">
                <div
                  className="flex items-center justify-center h-10 rounded-sm"
                  style={{
                    left: `calc(50% - ${halfWidth}vw)`,
                    width: `${halfWidth * 2}vw`,
                    minWidth: '15vw',
                    backgroundColor: item.fill, // SAME COLOR
                  }}
                >
                  <span className="text-sm md:text-md font-semibold text-white whitespace-nowrap">
                    {item.name}: {item.value.toLocaleString()} ({pct}%)
                  </span>
                </div>
              </div>
            );
          });
        })()}

      </div>
    </div>
  ) : (
    <div className="text-center py-10 text-gray-500">
      Select filters to view the workflow data
    </div>
  )}
</div>

          {/* BENEFIT */}
          <div className="w-full lg:w-72 bg-white p-6 rounded-lg shadow flex flex-col items-center justify-center">
            <h2 className="text-lg font-bold text-purple-800">
              Benefit Value
            </h2>
            <p className="text-2xl md:text-3xl font-bold text-purple-800 mt-2">
              ₹{schemeBenefit.toLocaleString('en-IN')}
            </p>
          </div>

        </div>

        {/* SNAPSHOT VIEW (FIXED) */}
        <div className="mt-6">
          <h2 className="text-lg md:text-xl font-semibold text-pink-800 mb-4">
            Snapshot View
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">

            <div className="bg-pink-100 p-5 rounded-xl text-center shadow">
              <h3 className="text-pink-800 font-semibold">Current Open</h3>
              <p className="text-2xl md:text-3xl font-bold mt-2">
                {currentOpen.toLocaleString()}
              </p>
            </div>

            <div className="bg-purple-100 p-5 rounded-xl text-center shadow">
              <h3 className="text-purple-800 font-semibold">Current DS</h3>
              <p className="text-2xl md:text-3xl font-bold mt-2">
                {currentDS.toLocaleString()}
              </p>
            </div>

            <div className="bg-indigo-100 p-5 rounded-xl text-center shadow">
              <h3 className="text-indigo-800 font-semibold">Current BR</h3>
              <p className="text-2xl md:text-3xl font-bold mt-2">
                {currentBR.toLocaleString()}
              </p>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
);
};

export default WaterfallChartComponent;